export enum SubscriptionStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

export type SubscriptionStatusType = `${SubscriptionStatusEnum}`;
